import React, { useState, useEffect, useRef } from 'react'

// import Loader from '../../../loader';

import HomeSteps01 from './HomeSteps_01';
import HomeSteps02 from './HomeSteps_02';
//import HomeSteps03 from './HomeSteps_03';

export default function Content(props) {

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const template = useRef({})
	const layout = useRef('')
	const content = useRef({})
	const pw = useRef({})

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(template.current = props.dados_config.info.template)
            set_dados(content.current = props.dados_config)
            set_dados(pw.current = props.pag_welcome)
            set_dados(layout.current = props.layout)

            setLoading(false)
        }

    }, [props]);

    return (isloading ?
		null
    :
        <>
            {
            layout.current === 'home-steps-01' ?
                <HomeSteps01 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-steps-02' ?
                <HomeSteps02 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-steps-04' ?
                <HomeSteps02 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
                <HomeSteps01 pag_welcome={pw.current} dados_config={dados_config.current} />
            }
        </>
    )
}
